import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import DeductionInvoiceList from '../../../components/Reconciliation/DeductionInvoiceList/DeductionInvoiceList';
import Spinner from '../../../components/Tools/spinner';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';

const DeductionListing = ({ config }) => {
    const navigate = useNavigate();
    const { financialYears } = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchStr, setSearchStr] = useState('');
    const [dateColumn, setDateColumn] = useState('voucher_date');
    const [loading, setLoading] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState([]);

    const handleAddChallan = () => {
        if (!selectedInvoice.length) {
            toast.error('Please select at least one invoice', {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }
        navigate(config.addPath, { state: { data: selectedInvoice } });
    };

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
        setFromDate('');
        setToDate('');
        setSearchStr('');
        setDateColumn('voucher_date');
    };

    return (
        <div>
            {loading && <Spinner />}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger} />
            <div className="row" style={{ padding: '10px 16px' }}>
                <div className="col-md-6">
                    <h4 style={{ color: '#28326f', margin: 0 }}>{config.title}</h4>
                    <CustomBreadcrumbs linksArray={[]} title={config.title} />
                </div>
                <div className="col-md-6">
                    {config.addPath && (
                        <div className="d-flex gap-2" style={{ width: 'auto', float: 'right' }}>
                            <button
                                type="button"
                                className="submit_button"
                                onClick={handleAddChallan}
                            >
                                Add Challan
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <div className="scheme p-3">
                <DeductionInvoiceList
                    apiFlag={config.apiFlag}
                    amountField={config.amountField}
                    amountHeader={config.amountHeader}
                    fromDate={fromDate}
                    toDate={toDate}
                    searchStr={searchStr}
                    dateColumn={dateColumn}
                    setLoading={setLoading}
                    setSelectednvoice={setSelectedInvoice}
                    holdingChallan={Boolean(config.holdingChallan)}
                />
            </div>
        </div>
    );
};

export default DeductionListing;
